import * as moment from 'moment';

export function getDayNumber(date: string, startDate: string, endDate: string): string {
  if (!startDate || !endDate) {
    return '';
  }

  const start = moment(startDate).startOf('day');
  const end = moment(endDate);
  const current = moment(date);

  // check if date is in range
  if (!current.isBetween(start, end, 'day', '[]')) {
    return 'Invalid day';
  }

  // calculate day number (difference + 1)
  const dayNumber = current.diff(start, 'days') + 1;

  return `Day ${dayNumber}`;
}
